import { CREATE_AGENT, CREATE_AGENT_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const createAgentRoute = createGlobalRoute({
  exact: true,
  name: CREATE_AGENT_PAGE,
  path: CREATE_AGENT,
  layout: 'home',
  nav4Layout: 'expanded',
  query: [
    'rovoChat!=false',
    'rovoChat.agentId!=false',
    'rovoChat.cloudId!=false',
    'rovoChat.conversationId!=false',
    'rovoChat.pathway!=false',
    'rovoChat.prompt!=false',
    'rovoChat!=false',
    'rovoChatAgentId!=false',
    'rovoChatCloudId!=false',
    'rovoChatConversationId!=false',
    'rovoChatPathway!=false',
    'rovoChatPrompt!=false',
    'rovoChatTriggerOpen!=false',
  ],
});
